export default Object.freeze({
  HOST_FAMILY: 4,
  DOCTOR: 30,
  DENTIST: 31
});
